import React from "react";

import { humaniseKey, shouldDisplayAuditField } from "./auditFormatters";
import { formatAuditFieldDisplayValue } from "./auditValueDisplay";

type AuditSnapshotSectionProps = {
  snapshot?: Record<string, unknown> | null;
};

export default function AuditSnapshotSection({
  snapshot,
}: AuditSnapshotSectionProps) {
  const entries = Object.entries(snapshot ?? {}).filter(([key]) =>
    shouldDisplayAuditField(key),
  );
  if (entries.length === 0) return null;

  return (
    <dl className="mt-3 grid grid-cols-1 gap-x-6 gap-y-1.5 sm:grid-cols-2">
      {entries.map(([key, val]) => (
        <div key={key} className="flex gap-2 text-sm">
          <dt className="font-medium text-[#0F172A]">{humaniseKey(key)}:</dt>
          <dd className="text-[#64748B]">
            {formatAuditFieldDisplayValue(key, val)}
          </dd>
        </div>
      ))}
    </dl>
  );
}
